import GooglePlacesTypeahead from './google-places-typeahead-directive';
import GooglePlacesTypeaheadService from './google-places-typeahead-service';
import GooglePlaces from './googlePlaces.directive';

const MODULE_NAME = 'google-places';
const module = angular
    .module(MODULE_NAME, [])
    .directive('googlePlacesTypeahead', GooglePlacesTypeahead)
    .directive('googlePlaces', GooglePlaces)
    .service('googlePlacesTypeaheadService', GooglePlacesTypeaheadService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/directives/google-places/google-places-module.js